import { render } from "./SpaziDataTable.vue?vue&type=template&id=20441654"
import script from "./SpaziDataTable.vue?vue&type=script&lang=js"
export * from "./SpaziDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__